import { render, staticRenderFns } from "./collaborator-item.vue?vue&type=template&id=67e4a62d"
import script from "./collaborator-item.vue?vue&type=script&lang=js"
export * from "./collaborator-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports